import React, { useState, useEffect, useContext } from 'react';
// import PropTypes from "prop-types";
import cn from 'classnames';
import { withStyles } from '@material-ui/styles';
import { DynamicForm } from '../../DynamicForm';
import * as v from '../../../helpers/validation';

// SERVICES
import {
  getClientSpecialInstructions,
  updateClientSpecialInstructions,
  createClientSpecialInstructions,
  getClientBundles,
  getProducts,
} from '../../../services';

const styles = theme => ({
  actionButton: {
    color: 'white',
    marginTop: 20,
  },

  actionButton: {
    backgroundColor: 'var(--jmi-blue)',
  },
});

const validateBundleAndProductAreNotBothSelected = () => (inputData, listItemData) => {
  return listItemData.clientBundleId && listItemData.productId
    ? 'You may only select a product or a bundle, but not both'
    : null;
};

export const ClientInstructionsTab = withStyles(styles)(({ clientId, classes }) => {
  const [initData, setInitData] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  const [productOptionsLoading, setProductOptionsLoading] = useState(false);
  const [clientBundleOptions, setClientBundleOptions] = useState([]);
  const [clientBundleOptionsLoading, setClientBundleOptionsLoading] = useState(false);

  const instructionInputs = [
    {
      inputType: 'array',
      field: 'clientSpecialInstructions',
      label: 'Client Special Instructions',
      validate: [],
      expansionTitleFormat: (data, index) => {
        return (
          <div className="row-between-center">
            <div>Type: {!!data.clientBundleId ? 'Bundle' : !!data.productId ? 'Product' : 'Client Generic'}</div>
            {!!data.clientBundleId ? (
              <div>Bundle code: {clientBundleOptions.find(cb => cb.value === data.clientBundleId)?.label}</div>
            ) : !!data.productId ? (
              <div>Product code: {productOptions.find(p => p.value === data.productId)?.label}</div>
            ) : null}
          </div>
        );
      },
      children: [
        {
          inputType: 'select',
          field: 'clientBundleId',
          label: 'Client Bundle',
          options: clientBundleOptions,
          validate: [validateBundleAndProductAreNotBothSelected()],
          extraProps: {
            isClearable: true,
            loading: clientBundleOptionsLoading,
          },
        },
        {
          inputType: 'select',
          field: 'productId',
          label: 'Product',
          options: productOptions,
          validate: [validateBundleAndProductAreNotBothSelected()],
          extraProps: {
            isClearable: true,
            loading: productOptionsLoading,
          },
        },
        {
          inputType: 'text',
          field: 'specialInstructions',
          label: 'Special Instructions',
          validate: [v.required()],
        },
      ],
    },
  ];

  const handleSubmit = async formData => {
    // const updatedInstructions = formData.clientSpecialInstructions.map(i => ({
    //   ...i,
    //   clientSpecialInstructionsId: i.clientSpecialInstructions ?? 0,
    // }));
    try {
      const results = await updateClientSpecialInstructions(clientId, formData.clientSpecialInstructions);
      return {
        clientSpecialInstructions: results,
      };
    } catch (error) {
      throw error;
    }
  };

  // get special instructions
  const getClientSpecialInstructionsAsync = async () => {
    try {
      const data = await getClientSpecialInstructions(clientId);

      setInitData({
        clientSpecialInstructions: data,
      });
    } catch (error) {
      console.log(error);
    }
  };

  // get client bundles
  const getClientBundlesAsync = async () => {
    try {
      setClientBundleOptionsLoading(true);
      const results = await getClientBundles(clientId);

      const opts = results.map(cb => ({
        value: cb.id,
        label: cb.bundleCode,
      }));

      setClientBundleOptions(opts);
    } catch (error) {
      console.log(error);
    }
    setClientBundleOptionsLoading(false);
  };

  // get products
  const getProductOptions = async () => {
    try {
      setProductOptionsLoading(true);
      const results = await getProducts(clientId);

      const opts = results.map(p => ({
        value: p.productId,
        label: `${p.productCode}`,
      }));

      setProductOptions(opts);
    } catch (error) {
      console.log(error);
    }
    setProductOptionsLoading(false);
  };

  useEffect(() => {
    getClientSpecialInstructionsAsync();
    getClientBundlesAsync();
    getProductOptions();
  }, []);

  return (
    <div className={cn('flex-1')}>
      <DynamicForm
        inputs={instructionInputs}
        mode={'EDIT'}
        data={initData}
        onSave={handleSubmit}
        //
      />
    </div>
  );
});

ClientInstructionsTab.propTypes = {};

ClientInstructionsTab.defaultProps = {};
